var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "syf-component-library/ui/atoms";
import SimpleModalPortal from "syf-component-library/ui/patterns/SimpleModalPortal";
import toolTipItems from "./helpers";
import { ToolTipBody, ToolTipTextWrapper, ToolTipTitle, ToolTipWrapper, } from "./subcomponents";
import modalIds from "../../../../const/modalIds";
import VantageTrans from "../../../atoms/VantageTrans";
var ToolTipPopUp = function (_a) {
    var isOpen = _a.isOpen, closeModal = _a.closeModal;
    return (_jsx(SimpleModalPortal, __assign({ id: "tooltip-popup", escapeModalHandler: closeModal, isOpen: isOpen, containerId: modalIds.TOOLTIP_MODAL_ID, "aria-labelledby": "ToolTipPopUp", "data-cy-include": true, "aria-describedby": "Shows Credit Score Info" }, { children: _jsxs(ToolTipWrapper, { children: [_jsxs(ToolTipTextWrapper, { children: [_jsx(ToolTipTitle, { children: _jsx(VantageTrans, { i18nKey: "creditToolTip.whatDoesCreditScoreMean" }) }), toolTipItems.map(function (item) { return (_jsxs(ToolTipBody, { children: [_jsx(VantageTrans, { i18nKey: "creditToolTip.".concat(item[0]), components: {
                                        em: _jsx("em", {}),
                                        strong: _jsx("strong", {}),
                                        br: _jsx("br", {}),
                                    } }), _jsx(VantageTrans, { i18nKey: "creditToolTip.".concat(item[1]), components: {
                                        em: _jsx("em", {}),
                                        strong: _jsx("strong", {}),
                                        br: _jsx("br", {}),
                                    } })] }, "creditToolTip.".concat(item[0]))); })] }), _jsx(Button, __assign({ onClick: closeModal, buttonType: "primary", type: "button", "data-type": "what is credit score", "data-analytics": "clicktrackingevent", "data-reason": "close" }, { children: _jsx(VantageTrans, { i18nKey: "actions.close" }) }))] }) })));
};
export default ToolTipPopUp;
